'use strict';
import React from 'react';
import Portal from 'react-portal';
import flux from 'utils/flux';
import TermsForm from './termsForm';
import AltContainer from 'alt-container';

var AcceptTermsPage = React.createClass({
    displayName: 'AcceptTermsPage',
    mixins: [],
    propTypes: {},
    statics: {
        willTransitionTo: function(transition) {
            if (!flux.getStore('app').isAuthenticated()) {
                transition.redirect('/login');
            }
            if (flux.getStore('app').hasAcceptedLatestTerms()) {
                transition.redirect('/');
            }
        }
    },

    getTitle(html) {
        return { __html: html };
    },

    componentDidMount() {

    },

    render() {
        return (
          <div className="page terms">
              <div className="container--centered">
                  <TermsForm />
              </div>
          </div>
        );
    }
});

module.exports = AcceptTermsPage;



// WEBPACK FOOTER //
// ./app/pages/acceptTerms/termsIndex.jsx